import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lineLogin from './util/lineLogin'
import { firebase } from './firebase/firebase'
import { Popup } from 'vant';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(Popup);

Vue.use(store)
Vue.use(ElementUI, { locale });
Vue.config.productionTip = false
if (process.env.NODE_ENV === 'development') {
  {
    updateFirebaseUserData({ userId: 'U59bea244c50cefc2beb6aea724e9eca5',displayName:"吳俊毅" })
      .then((userData) => {
        store.commit('SET_USERDATA', userData)
        initVue()
      })
  }

}
else {
  lineLogin.getUserData().then((data) => {
    return updateFirebaseUserData(data)
  })
    .then((databaseUserData) => {
      store.commit('SET_USERDATA', databaseUserData)
      initVue()
    })

    .catch(() => {
      lineLogin.redirect()
    })
}


function updateFirebaseUserData(lineData) {
  initActivityData()
  return new Promise((resolve) => {
    firebase.firestore().collection('publicMember').doc(lineData.userId).get().then((snap) => {
      if (snap.exists) {
        firebase.firestore().collection('publicMember').doc(lineData.userId).update(lineData)
        resolve(snap.data())
      }
      else {
        firebase.firestore().collection('publicMember').doc(lineData.userId).set(lineData)
        resolve(lineData)
      }
    })
  })

}
function initActivityData(){
  store.dispatch("initAllCourse");
  store.dispatch("initAllOutpatient");
}

function initVue() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}


